import { createAction } from 'redux-actions';
import * as phraseListModalTypes from './phraseListModalTypes';

export const showPhraseListModal = createAction(phraseListModalTypes.SHOW_PHRASE_LIST_MODAL);
export const setFilter = createAction(phraseListModalTypes.SET_FILTER);
export const submit = createAction(phraseListModalTypes.SUBMIT);
export const onLoad = createAction(phraseListModalTypes.LOAD);
export const hidePhraseListModal = createAction(phraseListModalTypes.HIDE_PHRASE_LIST_MODAL);
